import { NavLink } from "react-router-dom";
import "./mobile-card.scss";
import BoxIcon from "../../ui/box-icon/box-icon";
import { classNames } from "../../../lib/class-names";
import Icon from "../../ui/icon/icon";

type MobileCardPropsT = {
  title: string;
  linkTo: string;
  icon: string;
  isActiveTab: boolean;
  onClick: () => void;
};

const MobileCard: React.FC<MobileCardPropsT> = ({
  title,
  linkTo,
  icon,
  isActiveTab,
  onClick,
}: MobileCardPropsT) => {
  const cardClasse = classNames({
    "mobile-card": true,
    "mobile-card--active": !!isActiveTab,
  });

  return (
    <NavLink
      onClick={onClick}
      to={linkTo}
      style={{ height: "100%", maxHeight: "5.5rem" }}
    >
      <div className={cardClasse}>
        <div className="mobile-card__title-container">
          <BoxIcon
            icon={icon}
            size={"medium"}
            type={!!isActiveTab ? "primary" : "primary-disabled"}
          />
          <div className="mobile-card__title">{title}</div>
        </div>
        {!!isActiveTab && (
          <Icon
            name={"chevron-right"}
            size={"1.25rem"}
            className="mobile-card__chevron"
          />
        )}
      </div>
    </NavLink>
  );
};

export default MobileCard;
